<template>
      <div>
        <b-icon  icon="files" variant="dark" animation="throb" font-scale="4" />
        <hr>
        <div class="row">
                <p> 
                    <strong> {{data.name}} </strong> isimli kullanıcıyı seçtiğiniz firmanın bütün abonelerine kopyalamak üzeresiniz. Bu işlemin sonucunda  <strong> {{data.name}} </strong>
                     kullanıcısı firmanın bütün abonelerine eklenmiş olacaktır. Devam etmek için lütfen  <strong> {{data.name}} </strong> isimli kullanıcının kopyalanmasını istediğiniz 
                     firmayı seçiniz
                </p>
        </div>
        <hr /> 
      
     <validation-observer ref="CopyUser">
            <b-form class="formBox"> 
                <validation-provider name="Firma"  :rules="{ required: true }" v-slot="validationContext" >
                    <b-form-group class="inputGrp">
                        <div class="elements" >
                            <Multiselect v-model="company" :show-labels="false" @search-change=" s => searchCompany(s)" :options="companies" label="name" track-by="id"  :state='getValidationState(validationContext)'>
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <strong>{{ option.name }} </strong> 
                                </template>
                            </Multiselect>
                            <b-form-invalid-feedback id="live-feedback" style="display: block">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </div>
                    </b-form-group>
                    
                </validation-provider>
            </b-form>
            
        </validation-observer>
       
   </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    export default {
        name: "UserCopy",
        props:{
            data: Object,
            save: Boolean,
            saveState: Function,
            modalEvent: Function,
            modalName: String,
            sendRequest: Function,
        },
        created: function(){
            this.$store.dispatch('company_get')
        },
        components:{
            Multiselect
        },
        data: function(){
            return {
                company: undefined,
            }
        },
        computed:{
            companies: function(){
                return this.$store.getters.getCompanies
            }
        },
        methods:{
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
            searchSelect(s){
                let params = {}
                params['name'] = s
                this.$store.dispatch('company_get', params)

            },
        },
        watch: {
            save: async function(data){
                if(data){
                    this.$refs.CopyUser.validate().then( async (success) => {
                        if(success){
                            let data = { id: this.company.id, parent_id: parseInt(this.$route.params.id), user_id: this.data.id}
                            this.$store.dispatch('alarmuser_copy', data)

                            if(this.$store.getters.getAccountStatus.status == 'Success'){
                                this.modalEvent(false)
                            }
                        }
                    })
                }
                this.saveState(false)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/modals/UserCopy.vue